import { render, staticRenderFns } from "./MasterRequests.vue?vue&type=template&id=5dddb061&scoped=true"
import script from "./MasterRequests.vue?vue&type=script&lang=js"
export * from "./MasterRequests.vue?vue&type=script&lang=js"
import style0 from "./MasterRequests.vue?vue&type=style&index=0&id=5dddb061&prod&lang=scss&scoped=true"
import style1 from "./MasterRequests.vue?vue&type=style&index=1&id=5dddb061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dddb061",
  null
  
)

export default component.exports